<template>
  <b-col class="text-center">
    <span>
      {{ productName }} {{ xvisorVersion }} &copy; {{ new Date().getFullYear() }}
      <b-link :href="companyWebsite" target="_blank">
        {{ companyNameLong }}
      </b-link>
      All rights reserved.
    </span>
  </b-col>
</template>

<script>
export default {
  data() {
    return {
      xvisorVersion: '',
    };
  },
  mounted() {
    this.$http
      .get('/version.json')
      .then((result) => { this.xvisorVersion = result.data; });
  },
  computed: {
    companyNameLong() {
      return process.env.VUE_APP_COMPANY_NAME_LONG;
    },
    companyWebsite() {
      return process.env.VUE_APP_COMPANY_WEBSITE;
    },
    productName() {
      return process.env.VUE_APP_PRODUCT_NAME;
    },
  },
};
</script>
